
interface PricingFooterProps {
  needsRampUp: boolean;
}

export const PricingFooter = ({ needsRampUp }: PricingFooterProps) => {
  return (
    <div className="mt-8 text-sm text-muted-foreground text-center space-y-2 max-w-2xl mx-auto">
      <p>All plans include free shipping, dedicated medical support, and our care commitment.</p>
      {!needsRampUp && (
        <p>
          Your subscription will not automatically renew. You can choose to enable auto-renewal in your dashboard at any time.
        </p>
      )}
    </div>
  );
};
